import { render, staticRenderFns } from "./AddEventsDialog.vue?vue&type=template&id=01443c88"
import script from "./AddEventsDialog.vue?vue&type=script&lang=js"
export * from "./AddEventsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports